export const propertyTypeOptions = [
    { value: 'warehouse', label: 'Warehouse' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'truck-terminal', label: 'Truck Terminal' },
    { value: 'ios', label: 'Industrial Outdoor Storage (IOS)' },
    { value: 'land', label: 'Land' },
    { value: 'proposed_building', label: 'Proposed Building' },
    { value: 'existing_building', label: 'Existing Building' },
    { value: 'existing_building_park', label: 'Existing Building Park' },
    { value: 'existing_multi_tenant_building', label: 'Existing Multi-Tenant Building' },
];
export const occupancyOptions = [
    { value: 'leased', label: 'Leased' },
    { value: 'vacant', label: 'Vacant' },
    { value: 'owner_occupied', label: 'Owner occupied' },
];
export const availabilityOptions = [
    { value: 'available', label: 'Available' },
    { value: 'in_escrow', label: 'In Escrow' },
    { value: 'closed', label: 'Sold' },
    { value: 'sold', label: 'Sold' },
    { value: 'lease', label: 'For Lease' },
    { value: 'sub_lease', label: 'For Lease' },
    { value: 'leased', label: 'Leased' },
];
export const acquireAvailabilityOptionsFilter = [
    { value: 'available', label: 'For Sale' },
    { value: 'in_escrow', label: 'In Escrow' }
];
;
export const locationData = [
    {
        value: 'inland-empire',
        label: 'Inland Empire, CA',
        sublocations: [
            {
                value: 'inland-empire-ca-west',
                label: 'Inland Empire, CA West',
                sublocations: [
                    {
                        value: 'chino-ca',
                        label: 'Chino, CA',
                    },
                    {
                        value: 'ontario-ca',
                        label: 'Ontario, CA',
                    },
                    {
                        value: 'fontana-ca',
                        label: 'Fontana, CA',
                    },
                    {
                        value: 'rancho-cucamonga-ca',
                        label: 'Rancho Cucamonga, CA',
                    },
                    {
                        value: 'eastvale-ca',
                        label: 'Eastvale, CA',
                    },
                ]
            },
            {
                value: 'inland-empire-ca-central',
                label: 'Inland Empire, CA Central',
                sublocations: [
                    {
                        value: 'rialto-ca',
                        label: 'Rialto, CA',
                    },
                    {
                        value: 'bloomington-ca',
                        label: 'Bloomington, CA',
                    },
                    {
                        value: 'colton-ca',
                        label: 'Colton, CA',
                    },
                ]
            },
            {
                value: 'inland-empire-ca-east',
                label: 'Inland Empire, CA East',
                sublocations: [
                    {
                        value: 'perris-ca',
                        label: 'Perris, CA',
                    },
                    {
                        value: 'moreno-valley-ca',
                        label: 'Moreno Valley, CA',
                    },
                    {
                        value: 'redlands-ca',
                        label: 'Redlands, CA',
                    },
                    {
                        value: 'riverside-ca',
                        label: 'Riverside, CA',
                    },
                    {
                        value: 'san-bernardino-ca',
                        label: 'San Bernardino, CA',
                    },
                ]
            }
        ]
    }
];
